import { all } from 'redux-saga/effects';

import assuntosProblemas from './assuntos/saga';
import problemas from './problemas/saga';

export default all([problemas, assuntosProblemas]);
